module.exports = __webpack_public_path__ + "img/coxa-media-e.ae657d2a.png";